<ng-template #template let-row="row">
  <div class="flex--column">
    {{ row?.skuTitle }}
    <div class="text--label" *ngIf="row?.externalSkuId">{{ row.externalSkuId }}</div>
  </div>
</ng-template>
